<template>
  <v-col class="pa-0"></v-col>
</template>

<script>
export default {
  created() {},
  data() {
    return {};
  },
  name: 'template',
  props: [],
  watch: {},
  computed: {},
  methods: {},
};
</script>

<style scoped lang="scss">
</style>
